import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable()
export class HasResetCodeGuard implements CanActivate {
	constructor(private store: Store<any>, private router: Router) {}

	canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (next.queryParams.oobCode) {
			return true;
		}
		this.router.navigate(['/auth/password/forgot2']);
		return false;
	}
}
